import styled from 'styled-components';

export const AlignWord = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const Bola = styled.div`
  background-color: '#394D60';
  border-radius: 50%;
  width: 5px;
  height: 5px;
`;
